export const SATELLITE = "mapbox://styles/mapbox/satellite-v9";
export const MAP = "mapbox://styles/mapbox/light-v10";
